import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timezoneConverter',
})
@Injectable({
  providedIn: 'root',
})
export class TimezoneConverterPipe implements PipeTransform {
  transform(
    utcDate: string | Date | null | undefined,
    timezone: string = 'UTC',
    format: string = 'dd-MMM-yyyy hh:mm a',
    inputIsUTC: boolean = true
  ): string {
    if (!utcDate) {
      return '';
    }

    try {
      let date: Date;

      if (typeof utcDate === 'string') {
        if (
          inputIsUTC &&
          !utcDate.endsWith('Z') &&
          !utcDate.includes('+') &&
          !utcDate.includes('T') === false
        ) {
          date = new Date(utcDate + 'Z');
        } else {
          date = new Date(utcDate);
        }
      } else if (utcDate instanceof Date) {
        date = utcDate;
      } else {
        return '';
      }

      if (isNaN(date.getTime())) {
        return '';
      }

      return this.formatDateWithTimezone(date, timezone, format);
    } catch (error) {
      console.error('Error converting timezone:', error);
      return '';
    }
  }

  private formatDateWithTimezone(date: Date, timezone: string, format: string): string {
    const options: Intl.DateTimeFormatOptions = {
      timeZone: timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    };

    const parts = new Intl.DateTimeFormat('en-CA', options).formatToParts(date);
    const partsMap: any = parts.reduce((acc, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {} as Record<string, string>);

    const day = partsMap.day;
    const monthNum = partsMap.month;
    const year = partsMap.year;
    const hours24 = parseInt(partsMap.hour);
    const minutes = partsMap.minute;

    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const month = monthNames[parseInt(monthNum) - 1];

    const hours12 = hours24 % 12 || 12;
    const ampm = hours24 >= 12 ? 'PM' : 'AM';

    switch (format) {
      case 'dd-MMM-yyyy':
        return `${day}-${month}-${year}`;
      case 'dd-MMM-yyyy hh:mm a':
        return `${day}-${month}-${year} ${hours12.toString().padStart(2, '0')}:${minutes} ${ampm}`;
      case 'dd-MMM-yyyy HH:mm':
        return `${day}-${month}-${year} ${hours24.toString().padStart(2, '0')}:${minutes}`;
      case 'MMM dd, yyyy':
        return `${month} ${day}, ${year}`;
      case 'MMM dd, yyyy hh:mm a':
        return `${month} ${day}, ${year} ${hours12.toString().padStart(2, '0')}:${minutes} ${ampm}`;
      case 'yyyy-MM-dd HH:mm':
        return `${year}-${monthNum}-${day} ${hours24.toString().padStart(2, '0')}:${minutes}`;
      default:
        return `${day}-${month}-${year} ${hours12.toString().padStart(2, '0')}:${minutes} ${ampm}`;
    }
  }
}
